export const capitalize = (str: string) => {
  if (str.length > 1) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str.toUpperCase();
};
